// extracted by mini-css-extract-plugin
module.exports = {"CircleImage":"SMSResumePage_CircleImage__2Uycm"};